import { requestLoadingMobile } from "@/hooks/hooksMobile/useRequestLoadingMobile";
import { serviceQuickBiReportTemplateMobile } from "../services/bi/bi";
import { TableModule } from "@/component/common/report/reportConfigModel";
import { UseGetDataResultReturnType } from "@/component/PageComponent/hooks/requst";
import { isErrorMobile } from "@/component/PageComponentMobile/error";
import React from "react";
import { TemplateDataModel } from "@/component/Template/TemplateDataModel";
import { formatNumberByTemplate } from "@/component/ReportCommon/share/numberFormat";
import _, { omit, pick } from "lodash";
import { InfiniteScroll, List } from 'antd-mobile'
import { TableListHeader } from "./TableListHeader";
import { ReportConfig,SortParams,ReportParams, SortOrder } from '@/component/common/report/report';
import styled from "styled-components";
import { RightOutline } from 'antd-mobile-icons'
import { useLocation,useNavigate, useParams  } from 'react-router-dom'


const TableListView = styled.div`
  .list{
    .table-list{
      .list-item{
        border-bottom: 1px solid #e7e7e7;
        display: flex;
        position: relative;
        margin: 0 15px 0 20px;
        .index{
          display: block;
          content: '';
          width: 18px;
          height: 16px;
          border-radius: 0 10px 10px 0 ;
          background-color: #1890ff;
          position: absolute;
          top: 8px;
          margin-left: -20px;
          color: #fff;
          text-align: center;
          font-size: 10px;
          line-height: 16px;
        }
      }
      .list-item-left{
        display: flex;
        flex-wrap: wrap;
        flex: 1;
        padding: 5px 0 5px 0;
       
      }
      .item{
        width: 50%;
        /* min-height: 30px; */
        display: -webkit-box;
        align-items: center;
        color:#8c8c8c;
        padding:2px 2px 2px 0;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }  


`






interface TableListProps {

  reportTableData?:Array<Record<string,string|number>>,
  reportConfig: ReportConfig,
  source: string // 数据源
  moduleItem: TableModule
  dataHandler: UseGetDataResultReturnType<ReportParams>
  hasMore?:boolean

}



export const TableList = (props:TableListProps)=>{
  const { hasMore = true } = props
  const location  = useLocation()
  let {reportName = ''} = useParams<{reportName:string}>()
  const nagigate = useNavigate()  
  const { reportConfig, moduleItem,reportTableData,dataHandler} = props
  const [template, setTemplate] = React.useState<TemplateDataModel>({})
  const [detail,setDetail] = React.useState<Record<string,string|number>|undefined>(  )
  let templateFieldsObj =React.useMemo(()=>{
    return  _.keyBy(template?.fields,'code')
  },[template]);
  let defaultDisplayFields =React.useMemo(()=>{
    if(moduleItem.defaultDisplayFields?.length){
      return moduleItem.defaultDisplayFields
    }
    return template.fields?.map(item => item.code) || []
  },[template]).slice(0,8)
  const getTemplate = async () => {
    let template = await requestLoadingMobile(
      serviceQuickBiReportTemplateMobile({ report: reportConfig.config.slug, template_code: moduleItem.template_code })
    );
    if (isErrorMobile(template)) {
      return
    }
    setTemplate(template.data.data)
  }
  const loadMore = async () => {
    if(!reportTableData?.length){
      return
    }
    let pageInfo = dataHandler.pageInfo
    return dataHandler.setPageInfo({...pageInfo,page: pageInfo.page + 1,})
  }
  const onChangeSort = async (field:string,sort:keyof typeof SortOrder)=>{
    dataHandler.setParams({...dataHandler.params,sortParams:[{dataIndex:field,order:sort}]})
  }
  const codeToLabel = (item:Record<string,string|number>)=>{
    return Object.keys(item).map(code=>{
      return {
        label:templateFieldsObj[code]?.title,
        value: item[code]
      }
    })
  }
  const onShowDetail = (detail:Record<string,string|number>)=>{
    let cardDisplayField = pick(detail, (defaultDisplayFields || []).slice(0,6) );
    let displayDetail = omit(detail, defaultDisplayFields.slice(0,6) )
    nagigate(`/mobile/customReport/${reportName}/reportDetail`,{state:{
      list: codeToLabel( displayDetail ),
      card: codeToLabel( cardDisplayField ),
      title:  reportConfig.config.report_name
    }})
  }
  React.useEffect(()=>{
    getTemplate()
  },[])
  let data = reportTableData || []
  data = formatNumberByTemplate(data,templateFieldsObj)
  const sortParams = dataHandler.params.sortParams
  let sortField = moduleItem.sortField || []
  if( moduleItem.defaultSortFields ){
    let restSortField = sortField.filter(item => moduleItem.defaultSortFields.find(field => field.sortFieldId != item))
    sortField = [...moduleItem.defaultSortFields.map(item => item.sortFieldId),...restSortField];
  }
  return <TableListView>
    <div className="list" style={{display: detail ? 'none' : 'block'}}>
      <TableListHeader
        onChange={onChangeSort}
        sortField={sortField?.slice(0,4).map( item => ({label:  templateFieldsObj[item]?.title, value:item})) || []}
        sorts={sortParams?.map(item => ({ field: item.dataIndex, order: item.order })) || []}
      />
      <div className="table-list">
        {
          data.map((item,index) => {
            return <div className="list-item" key={index} onClick={() => onShowDetail(item)}>
              <span className="index">{ index+1}</span>
              <div className="list-item-left">
                {
                  defaultDisplayFields?.slice(0,8).map((field,index) => {
                    let label = templateFieldsObj[field]?.title || ''
                    let value = item[field]
                    return <div  className="item" key={field}>
                      {label}: {value}
                    </div>
                  })
                }
              </div>
              <RightOutline style={{margin:'9px 0 0 2px'}} />
            </div>
          })
        }
      </div>
      <InfiniteScroll loadMore={loadMore} hasMore={hasMore} /> 
    </div>
  </TableListView>


}
